import { combineReducers } from "redux";
import userReducer from "./userReducer";
import chatReducer from "./chatReducer";
import endUserChatReducer from "./endUserChatReducer";
import notLoginEndUserChatReducer from "./notLoginEndUserChatReducer";
import dashboardReducer from "./dashboardReducer";
import topMenuReducer from "./topMenuReducer";
import chartRangeReducer from "./chartRangeReducer";

export default combineReducers({
  user: userReducer,
  chat: chatReducer,
  endUserChat: endUserChatReducer,
  notLoginEndUserChat: notLoginEndUserChatReducer,
  dashboard: dashboardReducer,
  topMenu: topMenuReducer,
  chartRange: chartRangeReducer,
});
